// Packages
import React from "react";
import { computed, observable, action } from "mobx";
import { inject, observer } from "mobx-react";
// Components
import { Link } from "react-router-dom";
import { Icon, NavBar, SearchBar, Button, Modal, Toast } from "antd-mobile";
import JobCard from "../../compoents/cards/JobCard";

@inject("store")
@observer
class Jobs extends React.Component {
    @observable page = 1;
    @observable loading = false;
    @observable searchTerm = "";
    @observable showSearchBox = false;
    @observable activationLoading = false;
    @observable activationInfo = null;

    @computed get jobs() {
        return this.props.store.Job.jobs.filter((job) => {
            const index = job.name
                .toLowerCase()
                .search(this.searchTerm.toLowerCase());
            if (index !== -1) {
                return true;
            } else {
                return false;
            }
        });
    }

    @action.bound
    search(event) {
        this.searchTerm = event;
    }

    loadNextJobs() {
        this.loading = true;
        this.ref.current.focus();
        this.page = this.page + 1;
        this.props.store.Job.getJobs(this.props.history, this.page).then(
            (jobs) => {
                this.loading = false;
            }
        );
    }

    loadPreviousJobs() {
        this.loading = true;
        this.ref.current.focus();
        this.page = this.page - 1;
        this.props.store.Job.getJobs(this.props.history, this.page).then(
            (jobs) => {
                this.loading = false;
            }
        );
    }

    getPageNumber() {
        let page = this.props.match.params.page;

        if (Number.isNaN(page) || page === undefined) {
            page = 1;
        }

        return (this.page = page);
    }

    async componentDidMount() {
        if (this.jobs.length < 1) this.loading = true;
        this.props.store.Job.getJobs(
            this.props.history,
            this.getPageNumber()
        ).then((jobs) => {
            this.loading = false;
        });

        let account;
        try {
            account = await this.props.store.Account.getAccount();
        } catch (err) {
            // continue; we can still show modal without account details
        }

        console.log("Migration modal: account", account);
        setTimeout(() => this.showMigrationNotice(account), 200);
    }

    constructor(props) {
        super(props);
        this.ref = React.createRef();
    }

    getActivationApiBase() {
        return process.env.REACT_APP_ACTIVATION_API;
    }

    getAuthToken() {
        return (
            this.props.store?.root?.token ||
            localStorage.getItem("capturelife-token") ||
            sessionStorage.getItem("capturelife-token")
        );
    }

    async fetchActivationLink(accountId, prefetch = false) {
        const apiBase = this.getActivationApiBase();
        const token = this.getAuthToken();

        if (!apiBase) {
            Toast.fail("Activation service not configured", 2);
            return null;
        }

        if (!token) {
            Toast.fail("Missing auth token", 2);
            return null;
        }

        this.activationLoading = true;
        try {
            const res = await fetch(
                `${apiBase.replace(/\/$/, "")}/activation-link/${accountId}`,
                {
                    headers: {
                        Authorization: `Token ${token}`,
                    },
                }
            );

            if (!res.ok) {
                const msg = res.status === 404 ? "Link not found" : "Unable to fetch link";
                Toast.fail(msg, 2);
                return null;
            }

            const data = await res.json();
            if (prefetch) {
                this.activationInfo = data;
            }
            return data;
        } catch (err) {
            Toast.fail("Activation lookup failed", 2);
            return null;
        } finally {
            this.activationLoading = false;
        }
    }

    async showMigrationNotice(account) {
        const accountId = account?.id || this.props.store?.Account?.account?.id;

        console.log("Showing migration modal for account", accountId);
        if (accountId) {
            // Prefetch activation status so we can set the button label
            await this.fetchActivationLink(accountId, true);
        }
        const isActive = this.activationInfo?.active === true;
        const actionLabel = isActive
            ? "Go to GFcrew/Lite"
            : "Activate my account";

        const handleAction = async () => {
            if (!accountId) {
                Toast.fail("Missing account id", 2);
                return;
            }
            const data =
                this.activationInfo ||
                (await this.fetchActivationLink(accountId));
            if (!data) return;

            const targetUrl = data.active
                ? "https://lite.gfcrew.com"
                : data.activation_url;

            if (!targetUrl) {
                Toast.fail("Link not found", 2);
                return;
            }

            window.open(targetUrl, "_blank", "noopener,noreferrer");
            this.showMigrationModal = false;
        };

        Modal.alert(
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span>GFcrew/Lite</span>
                <span
                    onClick={() => {
                        this.showMigrationModal = false;
                        Modal.alert("", "", []); // force close
                    }}
                    style={{ cursor: "pointer", fontSize: "20px", lineHeight: "20px" }}
                >
                    ×
                </span>
            </div>,
            <div style={{ textAlign: "center" }}>
                <p>You have been migrated to the new GFcrew/Lite.</p>
                <p>This dashboard and the Capturelife portal will shutdown on 12/31</p>
                <p>Click below to continue.</p>
            </div>,
            [
                {
                    text: actionLabel,
                    onPress: handleAction,
                },
            ]
        );
    }

    render() {
        return (
            <>
                <NavBar
                    mode="light"
                    onLeftClick={() =>
                        this.showSearchBox
                            ? (this.showSearchBox = false)
                            : (this.showSearchBox = true)
                    }
                    leftContent={<Icon type="search" className="clickable" />}
                >
                    <img src="/assets/logo.png" alt="GF Crew Logo" />
                </NavBar>
                <div className="container">
                    <div className="flex-center">
                        <Link to="" ref={this.ref}></Link>
                        <Link
                            to="/jobs/new"
                            className="block-button am-button am-button-warning clickable"
                        >
                            ADD JOB
                        </Link>
                    </div>
                    {this.showSearchBox && (
                        <SearchBar
                            placeholder="Search jobs..."
                            value={this.searchTerm}
                            onChange={this.search}
                            onCancel={() => (this.searchTerm = "")}
                        />
                    )}
                    {this.loading && <Icon type="loading" />}
                    {this.jobs &&
                        this.jobs.map((job) => {
                            return <JobCard job={job} />;
                        })}
                    <div className="flex-center">
                        <Button
                            onClick={this.loadPreviousJobs.bind(this)}
                            className="block-button am-button am-button-ghost clickable p-4"
                            disabled={this.page <= 1}
                        >
                            Previous Jobs
                        </Button>
                        <Button
                            onClick={this.loadNextJobs.bind(this)}
                            className="block-button am-button am-button-ghost clickable p-4"
                            disabled={this.jobs.length < 99}
                        >
                            More Jobs
                        </Button>
                    </div>
                </div>
            </>
        );
    }
}

export default Jobs;
